import { useActiveTab, usePageHeaderProps } from '@va/dashboard/util-hooks';
import { FiltersContextProvider } from '@va/shared/feature-filters';
import { getVouchers, getVouchersInfo } from '@va/standalone/shared/actions';
import { accountSettingsTabNames } from '@va/standalone/shared/constants';
import { getOldestInstallDate, isSumoUser, userHasWebsites } from '@va/standalone/shared/selectors';
import { Filter } from '@va/types/filters';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ManageWebsitesContextProvider from './ManageWebsiteContext';
import ManageWebsitesPage from './ManageWebsitesPage';
import { REPORT_BLOCK_ID } from './ManageWebsitesRb';
import { useManageWebsitesFilters } from './useManageWebsitesFilters';

const ManageWebsitesContainer = () => {
  useActiveTab(accountSettingsTabNames.manageWebsites);
  const oldestInstallDate = useSelector(getOldestInstallDate);
  const hasWebsites = useSelector(userHasWebsites);
  const dispatch = useDispatch();
  const isUserSumo = useSelector(isSumoUser);

  useEffect(() => {
    if (isUserSumo) {
      dispatch(getVouchersInfo());
      dispatch(getVouchers());
    }
  }, [isUserSumo, dispatch]);

  const options: Filter[] = useManageWebsitesFilters();

  const pageHeaderProps = useMemo(
    () => ({ hideDatePicker: hasWebsites ? false : true, dateEnabled: oldestInstallDate }),
    [hasWebsites, oldestInstallDate],
  );

  usePageHeaderProps(pageHeaderProps);

  return (
    <FiltersContextProvider reportBlockId={REPORT_BLOCK_ID} allFilterOptions={options}>
      <ManageWebsitesContextProvider>
        <ManageWebsitesPage />
      </ManageWebsitesContextProvider>
    </FiltersContextProvider>
  );
};

export default ManageWebsitesContainer;
